import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./PPGoshaSans-Bold.woff2%22,%22style%22:%22normal%22,%22weight%22:%22700%22},{%22path%22:%22./PPGoshaSans-Regular.woff2%22,%22style%22:%22normal%22,%22weight%22:%22400%22}],%22preload%22:true,%22fallback%22:[%22system-ui%22,%22sans-serif%22],%22variable%22:%22--font-gosha%22}],%22variableName%22:%22ppGoshaSans%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'ppGoshaSans', 'ppGoshaSans Fallback', system-ui, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
